var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Comments")]),_vm._l((_vm.commentsAppendixData),function(content){return _c('div',{key:content.questionId},[_c('VCommentsAppendixQuestion',_vm._b({},'VCommentsAppendixQuestion',content,false)),_c('hr')],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }